<br>

<!--div class="form-row btntop2 col-sm-12 col-md-12" style="margin-top: 10px;min-width:500px;">

  <table>
    <tr>
      <td>
        <button class="btn border" [disabled]="
                                                form.get('selectedYears').value?.length===0 ||
                                               (form.get('selectedFilter')?.value==='3' && form.get('institutions')?.value?.length===0) ||
                                               (form.get('selectedFilter')?.value==='4' && form.get('districts')?.value?.length===0) ||
                                               ((form.get('selectedFilter')?.value!=='3' && form.get('selectedFilter')?.value!=='4' ) && (form.get('lodges')?.value === null && form.get('camps')?.value === null))" (click)="search()">Sök</button>
      </td>
      <td style="padding: 10px;">
        <button class="btn border" (click)="form.reset();selectedyears=[];selectedinstitutions=[];clearReport()">Rensa</button>
      </td>
    </tr>
  </table>
  <p [ngClass]="{'reportlabel': header.length < 22, 'reportlabel-long': header.length > 21}">Rapport: {{header}}<i *ngIf="showSpinner" class="pi pi-spin pi-spinner" style="font-size:22px;color:#920000;margin-left:30px;"></i></p>
</div-->

<div class="form-row btntop col-sm-12 d-flex align-items-center" style="margin-top: 10px;">
  <div class="d-flex justify-content-start w-100">
    <div class="d-flex align-items-center gap-2 w-100">
      
      <!-- Knapparna -->
      <div class="d-flex gap-1">
                <button class="btn border" [disabled]="
                                                form.get('selectedYears').value?.length===0 ||
                                               (form.get('selectedFilter')?.value==='3' && form.get('institutions')?.value?.length===0) ||
                                               (form.get('selectedFilter')?.value==='4' && form.get('districts')?.value?.length===0) ||
                                               ((form.get('selectedFilter')?.value!=='3' && form.get('selectedFilter')?.value!=='4' ) && (form.get('lodges')?.value === null && form.get('camps')?.value === null))" (click)="search()">Sök</button>
        <button class="btn border" (click)="form.reset();selectedyears=[];selectedinstitutions=[];clearReport()">Rensa</button>
      </div>

      <!-- Labeln -->
      <p class="reportlabel mb-0 ms-3">Rapport: {{header}}<i *ngIf="showSpinner" class="fa fa-spinner fa-spin" style="font-size:22px;color:#920000;margin-left:30px;"></i></p>
    </div>
  </div>
</div>

<div class="col-md-5 ms-4 me-4" style="min-width:500px;">
  <div class="border">
    <p style="margin-left:20px;margin-top:10px;"><b>ORGANISATION</b></p>
    <hr />
    <form [formGroup]="form" (keydown.enter)="search()">
      <div class="row">
        <div class="col-md-12">
          <mat-radio-group aria-label="Select an option" formControlName="selectedFilter" (change)="reset($event)" style="margin-left:20px;" class="d-flex justify-content-between me-3">
            <mat-radio-button value="1">Totalt loger</mat-radio-button>
            <mat-radio-button value="2">Totalt läger</mat-radio-button>
            <mat-radio-button value="3">Ange institution</mat-radio-button>
            <mat-radio-button value="4">Ange distrikt</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <br>
      <div class="col-md-4" *ngIf="form.get('selectedFilter').value === '1'">
        <p-selectButton [options]="lodges" formControlName="lodges"></p-selectButton>
      </div>
      <div class="col-md-4" *ngIf="form.get('selectedFilter').value === '2'">
        <p-selectButton [options]="camps" formControlName="camps">
        </p-selectButton>
      </div>
      <div *ngIf="header==='Närvaro på institutionsnivå' && (form.get('selectedFilter').value === '1' || form.get('selectedFilter').value === '2')" class="col-md-12">
        <br>
        <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red;font-size:20px;"></i><br>Med detta val kommer det ta lång tid innan rapportdatat hämtats. Räkna med ett par minuter vid val av ett år.
      </div>
      <div *ngIf="header==='Närvaro på institutionsnivå/månad' && (form.get('selectedFilter').value === '1' || form.get('selectedFilter').value === '2')" class="col-md-12">
        <br>
        <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color:red;font-size:20px;"></i><br>Med detta val kommer det ta lång tid innan alla poster hämtats. Räkna med ett par/tre minuter.
      </div>
    </form>
   
    <div class="row">
      <div class="col-md-6" *ngIf="form.get('selectedFilter').value === '3'" style="margin-left:20px;">
        <p-listbox *ngIf="multiple" #listbox [options]="institutionlist" [multiple]="multiple" [checkbox]="true" [(ngModel)]="selected" [filter]="true" optionLabel="name" [listStyle]="{'max-height':'200px'}" [style]="{'width':'300px'}" appendTo="body" (onChange)="setInstitution($event)">
        </p-listbox>
        <!--p-dropdown *ngIf="!multiple" [options]="institutionslist" [(ngModel)]="selected" [filter]="true" [showClear]="true" placeholder="Välj institution" [style]="{ width: '100%' }" (onChange)="setSingleInstitution()" [disabled]="form.get('selectedFilter').value!=='3'"></p-dropdown-->
        <p-select *ngIf="!multiple" [options]="institutionslist" [(ngModel)]="selected" optionLabel="shortName" [filter]="true" filterBy="label" [showClear]="true" placeholder="Välj institution" (onChange)="setSingleInstitution()" [disabled]="form.get('selectedFilter').value!=='3'" class="w-full md:w-56">
          <ng-template #selectedItem let-selectedOption>
            <div class="flex items-center gap-2">    
              <div>{{ selected.label }}</div>
            </div>
          </ng-template>
          <ng-template let-district #item>
            <div class="flex items-center gap-2">         
              <div>{{ district.label }}</div>
            </div>
          </ng-template>
        </p-select>


        {{selectedinstitution?.name}}
      </div>
      <div class="col-md-6" *ngIf="form.get('selectedFilter').value === '4'" style="margin-left:20px;">
        <p-listbox *ngIf="multiple" #listbox [options]="districtslist" [multiple]="multiple" [checkbox]="true" [(ngModel)]="selected" [filter]="true" optionLabel="name" [listStyle]="{'max-height':'200px'}" [style]="{'width':'300px'}" appendTo="body" (onChange)="setDistrict($event)">
        </p-listbox>
        <p-select *ngIf="!multiple" [options]="districtslist" [(ngModel)]="selected" [filter]="true" [showClear]="true" placeholder="Välj distrikt" [style]="{ width: '100%' }" (onChange)="setSingleDistrict()" [disabled]="form.get('selectedFilter').value!=='4'"></p-select>
        {{selectedinstitution?.name}}
      </div>
      <br><br>
    </div>
  </div>
  <br>
  <div class="border">
    <p style="margin-left:20px;margin-top:10px;"><b>ÅR</b></p>
    <hr />
    <div class="row">
      <div class="col-md-12">
        <table>
          <tr>
            <td>
              <div *ngIf="header==='Åldersfördelning'">
                <button class="btn btn-sm mb-1" (click)="selectLast15Years()" [disabled]="!form.get('selectedFilter').value">Välj senaste 15 åren</button>
              </div>
            </td>
          </tr>
          <tr>
            <td style="vertical-align: top;">
              <p-listbox *ngIf="!singleyear" [showToggleAll]="header!=='Åldersfördelning'" [options]="years" [(ngModel)]="selectedyears" [multiple]="true" [checkbox]="false" [filter]="false" optionLabel="year" [listStyle]="{'max-height':'150px'}" [style]="{'min-width':'110px', 'width':'110px'}"
                [disabled]="!form.get('selectedFilter').value" (onChange)="setYears()">
              </p-listbox>
              <div *ngIf="singleyear" class="d-flex justify-content-start"><input *ngIf="singleyear" type="text" style="width:60px" [(ngModel)]="selectedyear" [disabled]="!form.get('selectedFilter').value" (change)="setYears()"><span class="mx-2 align-items-center fw-lighter text-info">Klicka vid sidan av årtalet när det fyllts i.</span></div>
            </td>
            <td style="height:100px;">
              <div *ngFor="let y of selectedyears" style="margin-left:40px;">{{y.year}}</div>
            </td>
            <td>
              <div *ngIf="selectedyears.length > 0" class="col-md-1">
                <button class="btn btn-primary" style="width:30px;margin-left:4px;" title="Rensa valda år" (click)="selectedyears=[];setYears()"><i class="fa fa-times"></i></button>
              </div>
            </td>
          </tr>
        </table>
        <br>
        <div *ngIf="header === 'Orsaker'" class="col-md-6 ms-2">
          <form [formGroup]="form">
            <div *ngIf="form.get('endCause').value===null || form.get('endCause').value === ''">Startorsak:</div>
            <select *ngIf="form.get('endCause').value===null || form.get('endCause').value === ''" class="form-control form-control-sm" id="startCause" formControlName="startCause">
              <option></option>
              <option *ngFor="let c of causes" [value]="c.id">{{c.description}}</option>
            </select>
            <div *ngIf="form.get('startCause').value===null || form.get('startCause').value === ''">Slutorsak:</div>
            <select *ngIf="form.get('startCause').value===null || form.get('startCause').value === ''" class="form-control form-control-sm" id="endCause" formControlName="endCause">
              <option></option>
              <option *ngFor="let c of causes" [value]="c.id">{{c.description}}</option>
            </select>
          </form>
        </div>
      </div>
      <br>
    </div>
    <br>
  </div>